import Form from '../../../../../../components/form';
import request from '../../../../../../utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'dh_form',
    };
  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;

      return v;
    },

    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      console.log('formData____', formData);
      console.log('formData____', this.formConfig);
      if (formData) {
        const url = '/cps/v1/handleBanquetReward/updateLogisticsNo';
        const params = {
          id: this.formConfig.row.id,
          logisticsNo: formData.logisticsNo,
          logisticsCompany: formData.logisticsCompany,
        };
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
